import {
  Box,
  BoxProps,
  DividerProps,
  Theme,
  withStyles,
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsHeaderSmall from 'ui-elements/typography/FsHeaderSmall';
import FsBodySmallBold from 'ui-elements//typography/FsBodySmallBold';

export const IconContainerBox = withStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
}))((props) => <Box {...props} />);

export const ContainerBox = withStyles(
  ({ spacing, palette, breakpoints }: Theme) => ({
    root: {
      boxSizing: 'border-box',
      padding: spacing(2, 3),
      backgroundColor: palette.common.white,
      borderRight: `1px solid ${palette.grey[200]}`,
      borderTopLeftRadius: 0,
      cursor: 'pointer',
      width: '100%',
      [breakpoints.up('sm')]: {
        width: '50%',
      },
      [breakpoints.up('md')]: {
        width: 'auto',
        flexGrow: 1,
      },
    },
  })
)((props: BoxProps) => <Box {...props} />);

export const Label = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))((props: TypographyAllProps) => (
  <FsBodySmallBold component="h4" {...props} />
));

export const Value = withStyles(() => ({
  root: {
    fontSize: 20,
    lineHeight: 1,
  },
}))((props: TypographyAllProps) => <FsHeaderSmall component="p" {...props} />);

export const Line = withStyles((theme: Theme) => ({
  root: {
    width: 18,
    height: 2,
    margin: theme.spacing(1, 0),
    borderRadius: 2,
  },
}))((props: DividerProps) => <Divider {...props} />);
